import { createModel } from "hox";
import { useState } from "react"
import { IBasicDetail } from "./basicTypes"
import { basicService } from "./basicService";
import { message } from "antd";
export const basicModel = createModel(function () {
    const [fromVal, setFromVal] = useState<IBasicDetail>({})
    const getFormval = async () => {
        //基本信息只有一条这里是写死的
        let { retData } = await basicService.one("e61e1989231d4115970af52bac3ae5e4");
        setFromVal(retData)
    }
    const update = async (params: IBasicDetail) => {
        let { retData } = await basicService.update(params);
        if (retData) {
            getFormval();
            message.success("修改成功");
        }
    }
    return {
        fromVal, setFromVal,
        getFormval,
        update
    }
})